import { jsx as s } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { useBanner as f } from "./useBanner.js";
const p = c(function(e, i) {
  const { children: r, className: a, ...t } = e, n = f(t);
  if (!n.state.isVisible)
    return null;
  const o = typeof r == "function" ? r(n) : r;
  return /* @__PURE__ */ s(
    "section",
    {
      ref: i,
      "data-variant": e.variant ?? "info",
      ...n.bannerProps,
      className: a,
      style: void 0,
      children: o
    }
  );
});
export {
  p as AriaBanner
};
//# sourceMappingURL=Banner.js.map
